
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {dictApi,  mechanismApi} from "@/api/organization";
import baseUrl, {imageUrl} from "@/constants";
const {CodeToText} =require("@/js/region/region");
@Component
export default class organizationTable extends Vue {
  title = "单位信息";
  baseUrl = baseUrl
  imageUrl = imageUrl
  CodeToText = CodeToText
  mechanismDetail = { //单位详情
    visible: false,
    detail: null as any,
    updateVisible: false,
  }
  mechanismTypeData = {}
  levelData = {}
  /**
   * 编辑的id
   * */
  @Prop() private id!: any;
  @Prop() private status!: any;
  @Prop() private organizationType!: any; //所使用的页面的类型
  created() {
    if(this.id){
      this.init();
    }
  }
  init(){
    this.listDict();
    this.loadDetail();
  }
  //是否是授权机构
  isAuthMechanism(){
    return this.mechanismDetail.detail.type.indexOf("0006") > -1 || this.mechanismDetail.detail.type.indexOf("0008") > -1;
  }
  loadDetail(){
    mechanismApi.getMechanismAndUser(this.id).then(r => {
      if (r.data.result === 0) {
        const rData = r.data.data;
        this.mechanismDetail.detail = rData;
        this.mechanismDetail.visible = true;
      }
    })
  }
  listDict() {
    //单位类别
    dictApi.listDictItem({typeCode: "dwlb"}).then((r) => {
      if (r.data.result === 0) {
        const mechanismTypeData = {} as any;
        const dataList = r.data.data;
        dataList.forEach((d: any) => {
          mechanismTypeData[d.dictKey] = d;
        });
        mechanismTypeData['0005'] = {dictValue: '所在单位管理'}
        this.mechanismTypeData = mechanismTypeData;
      }
    });

    //单位级别
    dictApi.listDictItem({typeCode: "dwjb"}).then((r) => {
      if (r.data.result === 0) {
        const levelData = {} as any;
        const dataList = r.data.data;
        dataList.forEach((d: any) => {
          levelData[d.dictKey] = d;
        });
        this.levelData = levelData;
      }
    });
  }
}
